export default [
{
    value: 'Advertising Firm',
    label: 'Advertising Firm',
 },
 {
    value: 'Aquarium & Pets',
    label: 'Aquarium & Pets',
 },
 {
    value: 'Auto Services',
    label: 'Auto Services',
             
        children: [{
            value: 'Auto Detailing',
            label: 'Auto Detailing',
         },{
            value: 'Auto Repair',
            label: 'Auto Repair'
        },
    {
        value: 'Car Wash',
        label: 'Car Wash'
    },{
        value: 'Parking',
        label: 'Parking'
    },{
        value: 'Rent A Car',
        label: 'Rent A Car'
    },]},   

    {
        value: 'Beauty & Fitness',
        label: 'Beauty & Fitness',
                    
            children: [{
                value: 'Beauty Salon',
                label: 'Beauty Salon'
            },
        {
            value: 'Gym',
            label: 'Gym'
        },{
            value: 'Salon',
            label: 'Salon'
        },{
            value: 'Spa',
            label: 'Spa',
            },]},
 {
    value: 'Catering service',
    label: 'Catering service',
 },
 
 {
    value: 'CCTV Systems',
    label: 'CCTV Systems',
 },
 {
    value: 'CD House',
    label: 'CD House',
 },
 {
    value: 'Classes',
    label: 'Classes',
 },
 {
    value: 'Cushion Work',
    label: 'Cushion Work',
 },
 {
    value: 'Daycare',
    label: 'Daycare',
 },
 {
    value: 'Educational Institute',
    label: 'Educational Institute',
 },
 {
    value: 'Event Planning',
    label: 'Event Planning',
 },
 {
    value: 'Film hall',
    label: 'Film hall',
 },
 {
    value: 'Financial Services',
    label: 'Financial Services',
 },{
    value: 'Floral',
    label: 'Floral',
 },
 {
    value: 'Florist',
    label: 'Florist',
 },
 {
    value: 'Health & Medicine',
    label: 'Health & Medicine',
             
        children: [{
            value: 'Dental Care',
            label: 'Dental Care',
         },{
            value: 'Hospital',
            label: 'Hospital'
        },
    {
        value: 'Medical Center',
        label: 'Medical Center'
    },{
        value: 'Opticians',
        label: 'Opticians'
    },{
        value: 'Pharmacy',
        label: 'Pharmacy'
    },{
        value: 'Veterinary',
        label: 'Veterinary',
     },]},

     {
        value: 'Home Services',
        label: 'Home Services',
                 
            children: [{
                value: 'Constructors',
                label: 'Constructors',
             },{
                value: 'Electricians',
                label: 'Electricians'
            },
        {
            value: 'Home Cleaners',
            label: 'Home Cleaners'
        },{
            value: 'Landscaping',
            label: 'Landscaping'
        },{
            value: 'Plumbers',
            label: 'Plumbers'
        },]}, 

 {
    value: 'Hotel',
    label: 'Hotel',
 },
 {
    value: 'Laundry',
    label: 'Laundry',
 },
 {
    value: 'Online Services',
    label: 'Online Services',
                
        children: [{
            value: 'Digital Marketing',
            label: 'Digital Marketing'
        },
    {
        value: 'Graphic Design',
        label: 'Graphic Design'
    },{
        value: 'Software Development',
        label: 'Software Development'
    },{
        value: 'Web Development',
        label: 'Web Development',
        },]},

 {
    value: 'Pooja Items',
    label: 'Pooja Items',
 },
 {
    value: 'Pre School',
    label: 'Pre School',
 },
 {
    value: 'Printing',
    label: 'Printing',
 },
 {
    value: 'Repairs',
    label: 'Repairs',
                
        children: [{
            value: 'Computer Repairs',
            label: 'Computer Repairs'
        },
    {
        value: 'Electrical Repairs',
        label: 'Electrical Repairs'
    },{
        value: 'Phone Repairs',
        label: 'Phone Repairs'
    },{
        value: 'Watch Repair',
        label: 'Watch Repair',
        },]},

 {
    value: 'Resturant',
    label: 'Resturant',
 },
 {
    value: 'Safari Jeep',
    label: 'Safari Jeep',
 },
 {
    value: 'Studio',
    label: 'Studio',
 },
 {
    value: 'Supermarket',
    label: 'Supermarket',
 },
 {
    value: 'Tailors',
    label: 'Tailors',
 },{
    value: 'Transport',
    label: 'Transport',
 },{
    value: 'Wedding',
    label: 'Wedding',
 },

]


// WEBPACK FOOTER //
// ./src/data/services.js